import { appConfig } from 'brand-config';

/**
 * Whether this brand allows the underwriter MicroBilt-bypass at all (issue #33938). On for the
 * mutual brands, off for Branch. Read from the build-time brand config; the backend independently
 * re-checks the same brand flag, so this only controls whether the checkbox is even offered.
 */
export const isMicroBiltBypassAllowed = () => Boolean(appConfig?.featureFlags?.microBiltVerificationBypass);

/**
 * Resolves whether a MicroBilt-verification bypass should be sent for an ACH add (issue #33938).
 *
 * The "Bypass MicroBilt verification" checkbox is underwriting-only. This gate guarantees a
 * non-underwriter session can never send `bypassMicroBiltVerification: true` — even if the
 * checkbox value were somehow set — before it reaches the mutation / bind payload. The backend
 * independently re-checks `CanApproveUWReview`, so this is defense-in-depth on the FE.
 */
export const resolveMicroBiltBypass = (canApproveUWReview, checked) => Boolean(canApproveUWReview && checked);
